import { useEffect, useState } from 'react'
import { Typography, Card, Form, Row, Col } from 'antd'
import { WhatsAppOutlined, SendOutlined, ReloadOutlined } from '@ant-design/icons'
import Colors from '../utils/colors'
import { useDispatch, useSelector } from 'react-redux'
import { getWhatsAppMessage, updateWhatsAppMessage } from '../actions/constantsAction'
import { CustomButton } from '../components/ui/CustomButton'
import { CustomTextArea } from '../components/ui/CustomTextArea'
import { showToast } from '../utils/toast'

const { Title } = Typography

const Message = () => {
  const dispatch = useDispatch()
  const { message, loading, error, isUpdated } = useSelector((state) => state.whatsAppMessage)
  const [currentMessage, setCurrentMessage] = useState('')
  const [originalMessage, setOriginalMessage] = useState('')
  const [form] = Form.useForm()

  useEffect(() => {
    dispatch(getWhatsAppMessage())
  }, [dispatch])

  useEffect(() => {
    if (message) {
      setCurrentMessage(message)
      setOriginalMessage(message)
      form.setFieldsValue({ message })
    }
  }, [message, form])

  useEffect(() => {
    if (isUpdated) {
      showToast('Message updated successfully', 'success')
    }

    if (error) {
      showToast(error, 'error')
    }
  }, [isUpdated, error])

  const handleSubmit = () => {
    dispatch(updateWhatsAppMessage(currentMessage))
  }

  const handleReset = () => {
    setCurrentMessage(originalMessage)
    form.setFieldsValue({ message: originalMessage })
  }

  return (
    <div>
      <Title level={4} style={{ color: Colors.primary, marginBottom: 22, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <WhatsAppOutlined style={{ transform: 'scale(1.5)', marginRight: 12, color: Colors.whatsapp }} />
        WhatsApp Message
      </Title>

      <Card style={{ borderRadius: '8px' }}>
        <Form form={form} layout="vertical">
          <Form.Item
            name="message"
            label="Message Template"
            rules={[{ required: true, message: 'Please enter a message' }]}
          >
            <CustomTextArea
              value={currentMessage}
              onChange={(e) => setCurrentMessage(e.target.value)}
              placeholder="Enter your WhatsApp message template..."
              rows={10}
              style={{ resize: 'vertical' }}
            />
          </Form.Item>
          
          <Row gutter={16}>
            <Col>
              <CustomButton
                classNames='create-btn'
                onClick={handleSubmit}
                loading={loading}
                style={{ 
                  height: '28px',
                  fontSize: '10px',
                  width: 'auto'
                }}
              >
                <SendOutlined /> Submit
              </CustomButton>
            </Col>
            <Col>
              <CustomButton
                onClick={handleReset}
                style={{ 
                  height: '28px',
                  fontSize: '10px',
                  width: 'auto'
                }}
              >
                <ReloadOutlined /> Reset
              </CustomButton>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  )
}

export default Message